import { Outlet } from 'react-router-dom'
import SideNav from '@/components/SideNavbar'
import { BranchProvider } from '@/modules/teacher/context/BranchContext'
import PageLoader from '@/shared/components/PageLoader'
import { useAuth } from '@/shared/context/AuthContext'

export default function UserLayout() {
    const { isLoading } = useAuth()

    return isLoading ? (
        <PageLoader />
    ) : (
        <SideNav>
            <BranchProvider>
                <Outlet />
            </BranchProvider>
        </SideNav>
    )
}
